import React from "react";
import { Space, Typography } from "antd";
import AvatarComponent from "../AvatarComponent";
import TwizzLogo from "../../assets/icons/logo-black.svg";
import AdScriptComponent from "../AdScriptComponent/AdScriptComponent";
import "./FanHomeAdComponent.less";

interface FanHomeAdComponentProps {
  adContent: string;
}

const FanHomeAdComponent: React.FC<FanHomeAdComponentProps> = ({ adContent }) => {
  if (!adContent) {
    return null;
  }

  return (
    <div className="main-content-wrapper">
      <div className="main-content-header mt-5 main-content-header-ads">
        <Space>
          <AvatarComponent className="cursor-pointer" image={TwizzLogo} size={34} />
          <Typography.Text className="slideItemNameLabel cursor-pointer">Twizz</Typography.Text>
        </Space>
      </div>
      <div className="main-container-image mt-5">
        <div className="slideItemPostImg slideItemPostImg-ad">
          <AdScriptComponent content={adContent} />
        </div>
      </div>
      <div className="slideItemFooter">
        <Space className="mb-6">
          <Typography.Text className="slideItemLikeLabel">Sponsored content</Typography.Text>
        </Space>
        <br />
        <Typography.Text className="slideItemLikeLabel">
          <span>Twizz</span> Advertisement
        </Typography.Text>
      </div>
    </div>
  );
};

export default FanHomeAdComponent;
